import { render, staticRenderFns } from "./master-assessment-report.vue?vue&type=template&id=9791f434"
import script from "./master-assessment-report.vue?vue&type=script&lang=js"
export * from "./master-assessment-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports